import {SAVE_MERCANCIAS, MercanciaActionTypes} from "../types/mercanciaActionTypes";
import {Mercancia} from "../../entities/solicitudes/Mercancia";

export function saveMercancias(mercancias: Mercancia[]): MercanciaActionTypes {
    return{
        type: SAVE_MERCANCIAS,
        mercancias
    }
}
